import { FC } from 'react';
import { Box, GridItem, GridItemProps } from '@chakra-ui/react';
import { ColorName } from '@shinetools/sunshine';

import { BODY_GRID_AREA } from '../../constants';

interface BodyProps extends GridItemProps {
  colorScheme: ColorName;
}

const Body: FC<BodyProps> = ({ children, colorScheme, ...props }) => (
  <GridItem
    {...props}
    gridArea={BODY_GRID_AREA}
    overflowX="hidden"
    overflowY="auto"
    position="relative"
  >
    <Box
      backgroundColor={`${colorScheme}.100`}
      borderBottomRadius="50%"
      height="350px"
      left="-180px"
      position="absolute"
      right="-180px"
    />

    <Box
      height="100%"
      marginX="auto"
      maxWidth="794px"
      paddingY="space-52"
      position="relative"
      zIndex={1}
    >
      {children}
    </Box>
  </GridItem>
);

export default Body;
